import React, { Component } from 'react';

// Externals
import PropTypes from 'prop-types';
import axios from 'axios';
import compose from 'recompose/compose';
import { withRouter } from "react-router-dom";

// Material helpers
import { withStyles } from '@material-ui/core';

// Material components
import { Grid } from '@material-ui/core';

// Shared layouts
import { Application as ApplicationLayout } from 'layouts';

// components

import ContactTabs from './components/ContactTabs';

// Auth
// import AuthHelperMethods from 'components/Auth/AuthHelperMethods.jsx';
import withAuth from 'components/Auth/withAuth.jsx';

// Component styles
const styles = theme => ({
  root: {
    padding: theme.spacing.unit * 4
  },
  item: {
    height: '100%'
  }
});

class ContactProfile extends Component {
  _isMounted = false;

  constructor(props) {
    super(props);
    this.state = {
      contactProfile: { id: '',
                     attributes: {}
                   },
    };
  }


  componentDidMount() {
    this._isMounted = true;
    const { match } = this.props;
    const confirm = this.props.confirm;
    const profileId = Number(match.params.id);
    console.log(confirm);
    let url = `${process.env.REACT_APP_API_URL}leads/` + profileId + '.json';
    axios
      .get(url,{headers:{ Authorization: 'Bearer ' + confirm }})
      .then(response => {
        if (this._isMounted) {
        this.setState({ contactProfile: response.data.data });
        console.log(response.data.data);
        }
      })
      .catch((error) => {
        console.log(error);
      });

  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  render() {
    const { contactProfile } = this.state;
    const { classes } = this.props;


    return (
      <ApplicationLayout title={`Lead ref: ${contactProfile.id}`} >
        <div className={classes.root}>
          <Grid
            container
            spacing={8}
            justify="center"
          >

            <Grid
              item
              lg={12}
              md={12}
              xl={12}
              xs={12}
            >
            <ContactTabs profile={contactProfile}></ContactTabs>

            </Grid>

          </Grid>
        </div>
      </ApplicationLayout>
    );
  }
}

ContactProfile.propTypes = {
  classes: PropTypes.object.isRequired
};

export default compose(
  withAuth,
  withStyles(styles),
  withRouter
)(ContactProfile);
